import { render, staticRenderFns } from "./BtnStartAnalizAI.vue?vue&type=template&id=6f55c81e"
import script from "./BtnStartAnalizAI.vue?vue&type=script&lang=js"
export * from "./BtnStartAnalizAI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports